module.exports = __webpack_public_path__ + "img/icon-video.7d1d9abb.svg";